module.exports = __webpack_public_path__ + "img/ZCL.5c9d5c13.svg";